import { createFileRoute } from '@tanstack/react-router';

import { APICredentials } from '@/features/settings';

export const Route = createFileRoute('/_auth/settings/api')({
  component: APICredentials,
  notFoundComponent: () => {
    return <p>API credentials not found!</p>;
  },
});
